import { string, addMethod } from 'yup';
import { stripTn } from './stripTn';

/**
 * Adds a method to yup.string that removes all characters from a TN except for digits and letters if vanity is allowed.
 * The Yup method that gets created accepts the same optional parameters to override the defaults.
 *
 * @module
 *
 * @param {boolean} [defaultAllowVanity=false] The default for allowing vanity numbers when the yup method is invoked with no arguments
 * @param {boolean} [defaultTruncateVanity=false] The default for truncating vanity numbers when the yup method is invoked with no arguments
 *
 * @example
 * import { addStripTnToYup } from '@somosgov/js-util-lib';
 * import { string, object } from 'yup'
 *
 * // Add the method to Yup
 * addStripTnToYup();
 *
 * // Using the method in a schema
 * const schema = object({
 *    // use defaults
 *    tfn: string().stripTn(),
 *    // Allow and truncate vanity
 *    tfn: string().stripTn(true, true),
 * })
 *
 */
const addStripTnToYup = (
   defaultAllowVanity = false,
   defaultTruncateVanity = false
) =>
   addMethod(string, 'stripTn', function stripTnYup(
      allowVanity = defaultAllowVanity,
      truncateVanity = defaultTruncateVanity
   ) {
      return this.transform(value =>
         stripTn(value, allowVanity, truncateVanity)
      );
   });

export { addStripTnToYup };
